const main = require('./main');

Odigeo.defineWidget('collapsible_flight_summary', Odigeo.Widget.extend(Odigeo._.merge({}, main, {
    modelClass: require('./model'),
    viewClass: require('./view.desktop'),
})));
